<template>
    <rkm-area
        no-margin-top
        title="Declaração de comparecimento"
    >
        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.declaracaoComparecimento.entrada"
                    label="Entrada"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.declaracaoComparecimento.saida"
                    label="Saída"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.declaracaoComparecimento.turno
                        ? item.declaracaoComparecimento.turno.nome : 'Horário personalizado'"
                    label="Turno"
                />
            </rkm-col>

            <rkm-col cols="6">
                <Item
                    :get-value="() => item.declaracaoComparecimento.nomeAcompanhante"
                    label="Nome do acompanhante"
                />
            </rkm-col>

            <rkm-col cols="12">
                <Item
                    :get-value="() => item.declaracaoComparecimento.motivoComparecimento"
                    label="Motivo do comparecimento"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>